/**
 * Orchestration layer for marketing list routes.
 *
 * Master Rules §2: UI components must not fetch. This module owns the
 * list-fetch side effect via useListPatternItems and passes derived state
 * into the presentational ContentListPage shell.
 */
import { useListPatternItems } from '../hooks/useListPatternItems';
import type { ContentListPageShellProps, ListPatternProps } from '../lib/contentListPageTypes';
import { ContentListPage } from './ContentListPage';

export type ListContentListPageProps = ContentListPageShellProps & {
  listProps: ListPatternProps;
};

export function ListContentListPage({ listProps, ...shell }: ListContentListPageProps) {
  const listState = useListPatternItems(listProps, shell.title);

  return <ContentListPage {...shell} listProps={listProps} listState={listState} />;
}
